import { PhaseTierConfigManager } from "@/components/admin/PhaseTierConfigManager";

export default function TierConfiguration() {
  return (
    <div className="container mx-auto py-8 space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Good / Better / Best Configuration</h1>
        <p className="text-muted-foreground mt-2">
          Configure three-tier product options for each installation phase. Set up Good, Better, and Best product choices that sales reps can switch between during estimate building.
        </p>
      </div>

      <PhaseTierConfigManager />
    </div>
  );
}
